$(document).ready(function(){

    jQuery('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>').insertAfter('.quantity input');
    jQuery('.quantity').each(function() {
      var spinner = jQuery(this),
        input = spinner.find('input[type="number"]'),
        btnUp = spinner.find('.quantity-up'),
        btnDown = spinner.find('.quantity-down'),
        min = input.attr('min'),
        max = input.attr('max');

      btnUp.click(function() {
        var oldValue = parseFloat(input.val());
        if (oldValue >= max) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue + 1;
        }
        spinner.find("input").val(newVal);
        spinner.find("input").trigger("change");
      });

      btnDown.click(function() {
        var oldValue = parseFloat(input.val());
        if (oldValue <= min) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue - 1;
        }
        spinner.find("input").val(newVal);
        spinner.find("input").trigger("change");
      });

    });

    $('.add_msg').click(function(){
      $(this).next('.add_msg_box').slideToggle();
      if ($(this).next('.add_msg_box').is(':visible')){
        $(this).next('.add_msg_box').find('textarea').focus();
      } else {
        $(this).next('.add_msg_box').find('textarea').blur();
      }
    });

    // $('.toggle-set').click(function(){
    //     if ($(this).siblings(".toggle-jewellery").hasClass('show')) {
    //         $(this).parents('.related-items-toggle').siblings(".related-items.jewellery").removeClass('show').addClass('hide');
    //         $(this).siblings('.toggle-jewellery').removeClass('show').addClass('hide');
    //     }
    //     $(this).toggleClass('hide show');
    //     $(this).parents('.related-items-toggle').siblings(".related-items.set").toggleClass('hide show');
    // });
    // $('.toggle-jewellery').click(function(){
    //     if ($(this).siblings('.toggle-set').hasClass('show')) {
    //         $(this).parents('.related-items-toggle').siblings(".related-items.set").removeClass('show').addClass('hide');
    //         $(this).siblings('.toggle-set').removeClass('show').addClass('hide');
    //     }
    //     $(this).toggleClass('hide show');
    //     $(this).parents('.related-items-toggle').siblings(".related-items.jewellery").toggleClass('hide show');
    // });

    $('.toggle-set').click(function(){
        if ($(this).siblings(".toggle-jewellery").hasClass('show')) {
            $(this).parents('.related-items-toggle').siblings(".related-items.jewellery").slideToggle();
            $(this).siblings('.toggle-jewellery').removeClass('show').addClass('hide');
        }
        $(this).toggleClass('hide show');
        $(this).parents('.related-items-toggle').siblings(".related-items.set").slideToggle();
    });
    $('.toggle-jewellery').click(function(){
        if ($(this).siblings('.toggle-set').hasClass('show')) {
            $(this).parents('.related-items-toggle').siblings(".related-items.set").slideToggle();
            $(this).siblings('.toggle-set').removeClass('show').addClass('hide');
        }
        $(this).toggleClass('hide show');
        $(this).parents('.related-items-toggle').siblings(".related-items.jewellery").slideToggle();
    });

    // check if send to friend is checked
    $('.shipping-selections .radiogroup').each(function() {
      if ($(this).is(":checked")) {
        $(this).parents('.checkbox').siblings().find('input').prop('checked', false);
    
        if ($(this).val() == 'friend' && $(this).parents('.shipping-selections').siblings('.shipping-friend').hasClass('hide')) {
          // console.log('friend');
          $('.shipping-friend').addClass('show').removeClass('hide').show();
          $('.shipping-friend input, .shipping-friend select, .shipping-friend textarea').each(function() {
            $(this).prop('name', $(this).data('name'));
        });
        } else {
          // console.log('other');
          $('.shipping-friend').addClass('hide').removeClass('show').hide();
          $('.shipping-friend input, .shipping-friend select, .shipping-friend textarea').each(function() {
            $(this).removeAttr('name');
          });
        }
      }
    });

    
});//END READY

// custom product promo
$("#custom-promo-fields-trigger").on("click", function() {
  
  if ($(this).is(":checked")) {
      $(this).parents('.custom-promo-fields-trigger-holder').siblings('.custom-promo-fields').show().css({'visibility':'visible','height':'auto'});
      $(this).siblings('label').text('Remove free gift');

      $('.custom-promo-fields input, .custom-promo-fields select').each(function() {
          $(this).prop('name', $(this).data('name'));
      });
  } else {
      $(this).parents('.custom-promo-fields-trigger-holder').siblings('.custom-promo-fields').hide().css({'visibility':'hidden','height':'0'});
      $(this).siblings('label').text('Select your gift');
      
      $('.custom-promo-fields input, .custom-promo-fields select').each(function() {
          $(this).removeAttr('name');
      });
  }
});

$(".radiogroup").on("click", function() {
  if ($(this).is(":checked")) {
    $(this).parents('.checkbox').siblings().find('input').prop('checked', false);

    if ($(this).val() == 'friend' && $(this).parents('.shipping-selections').siblings('.shipping-friend').hasClass('hide')) {
      // console.log('friend');
      $('.shipping-friend').addClass('show').removeClass('hide').show();
      $('.shipping-friend input, .shipping-friend select, .shipping-friend textarea').each(function() {
        $(this).prop('name', $(this).data('name'));
    });
    } else {
      // console.log('other');
      $('.shipping-friend').addClass('hide').removeClass('show').hide();
      $('.shipping-friend input, .shipping-friend select, .shipping-friend textarea').each(function() {
        $(this).removeAttr('name');
      });
    }
  }
});

